import { render, staticRenderFns } from "./GroupTableHeader.vue?vue&type=template&id=5a2b0053&"
import script from "./GroupTableHeader.vue?vue&type=script&lang=js&"
export * from "./GroupTableHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports